import RfiTemplatesTable from './RfiTemplatesTable.component';

export default RfiTemplatesTable;
